import React from 'react'
import PinTableContainer from '../containers/PinTableContainer'

const Pinout = ({
  component,
  showEmptyPinsToggle,
  showEmptyPinsDefault,
  enablePinSelection,
  vin,
  isLoading,
  open,
}) => {
  if (!component) return <div />

  return (
    <PinTableContainer
      component={component}
      showEmptyPinsDefault={showEmptyPinsDefault}
      showEmptyPinsToggle={showEmptyPinsToggle}
      enablePinSelection={enablePinSelection}
      vin={vin}
      isLoading={isLoading}
      open={open}
    />
  )
}

export default Pinout
